import React from "react";
import { View, Text } from "react-native";
import { BG_STYLES, COMMON_STYLES } from "@dehaat/dds";
import {
  BORDER_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";

interface TechnicalListProps {
  items: string[];
}

const TechnicalList= ({ items }:TechnicalListProps) => {
  if (!items || items.length === 0) return null;

  return (
    <View
      style={[
        COMMON_STYLES.p1,
        BG_STYLES.bgWhite,
        COMMON_STYLES.b1,
        COMMON_STYLES["br1/2"],
        BORDER_STYLES.borderNeutral20,
        COMMON_STYLES.mb1,
      ]}
    >
      {items.map((technical, index) => (
        <View
          key={index}
          style={[
            COMMON_STYLES.row,
            COMMON_STYLES.alignItemsCenter,
            COMMON_STYLES["mb3/4"],
          ]}
        >
          <Text style={{ fontSize: 20, lineHeight: 24, marginRight: 6 }}>•</Text>
          <Text style={[TYPOGRAPHY.TEXT1, VARIANTS_STYLES.BASE]}>
            {technical}
          </Text>
        </View>
      ))}
    </View>
  );
};

export default TechnicalList;